import { useSyncExternalStore } from 'react';
import { getSnapshot, subscribe, type Snapshot } from '../store/state.ts';
import { isUpdateAvailable, subscribeToUpdate } from '../lib/update.ts';
import { getTheme, subscribeToTheme, type ThemeChoice } from '../lib/theme.ts';

/**
 * `useSyncExternalStore` plutôt qu'un contexte React : le store vit hors de
 * React (le moteur de synchronisation l'écrit depuis des timers), et c'est
 * l'API prévue pour ce cas.
 */
export function useStore(): Snapshot {
  return useSyncExternalStore(subscribe, getSnapshot);
}

export function useUpdateAvailable(): boolean {
  return useSyncExternalStore(subscribeToUpdate, isUpdateAvailable);
}

export function useTheme(): ThemeChoice {
  return useSyncExternalStore(subscribeToTheme, getTheme);
}

/**
 * Re-rend le composant à intervalle régulier, pour que les horodatages relatifs
 * (« il y a 5 min ») restent justes sans qu'aucune donnée ne change.
 *
 * Purement local : aucun réseau, aucun coût de quota.
 */
export function useTicker(intervalMs = 30_000): number {
  return useSyncExternalStore(
    (listener) => {
      const id = setInterval(listener, intervalMs);
      return () => clearInterval(id);
    },
    () => Math.floor(Date.now() / intervalMs),
  );
}
